/**
 * Google Ads tag loader for the GatorNotes ad account.
 * The tag loads only after the visitor accepts cookies in the banner
 * (gn_cookie_consent === "all"). Consent Mode defaults in index.html
 * start denied; accepting the banner lifts them.
 */

const AW_ID = "AW-18520796296";
export const CONSENT_KEY = "gn_cookie_consent";

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export function hasAdConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === "all";
  } catch {
    return false;
  }
}

export function updateConsent(decision: "granted" | "denied") {
  window.gtag?.("consent", "update", {
    ad_storage: decision,
    ad_user_data: decision,
    ad_personalization: decision,
  });
}

/** Loads the Google tag if the visitor has accepted cookies. Safe to call repeatedly. */
export function loadGoogleAds() {
  if (!hasAdConsent()) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function (...args: unknown[]) {
      window.dataLayer.push(args);
    };
  updateConsent("granted");
  if (document.querySelector("script[data-google-ads]")) return;
  window.gtag("js", new Date());
  window.gtag("config", AW_ID);
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${AW_ID}`;
  script.async = true;
  script.dataset.googleAds = "";
  document.head.appendChild(script);
}
